import { find, map } from 'lodash'
import { VendorData } from '../apis/vendor.api'

export default {
  searchOptions (vendors: VendorData[]) {
    return map(vendors, vendor => {
      const { id, name } = vendor
      return { id, value: name }
    })
  },

  find (vendors: VendorData[], id: number) {
    return find(vendors, { id })
  }
}
